import { createAction } from '@reduxjs/toolkit';

/**
 * Global action used to signal that every slice should reset to its initial state.
 */
export const resetAppState = createAction('app/reset');

export type ResetAppStateAction = ReturnType<typeof resetAppState>;



